import { styled } from "@mui/material";

export const LayoutBasicPage = styled("div")({
  display: "flex",
  minHeight: "100vh",
});
